import NavigateBeforeIcon from "@mui/icons-material/ChevronLeft";
import NavigateNextIcon from "@mui/icons-material/ChevronRight";
import LastPageIcon from "@mui/icons-material/SkipNext";
import FirstPageIcon from "@mui/icons-material/SkipPrevious";
import { Button, Box, useTheme } from "@mui/material";

function Pagination({ page, setPage, totalItems, itemsPerPage }) {
  const theme = useTheme();
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, index) => index);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={1}
      mt={2}
    >
      <Button
        onClick={() => setPage(0)}
        disabled={page === 0}
        startIcon={<FirstPageIcon />}
        sx={{
          width: "32px !important",
          minWidth: "32px",
        }}
      />
      <Button
        onClick={() => setPage(page - 1)}
        disabled={page === 0}
        startIcon={<NavigateBeforeIcon />}
        sx={{
          width: "32px !important",
          minWidth: "32px",
        }}
      />
      {pages.map((pageNumber) => (
        <Button
          key={pageNumber}
          onClick={() => setPage(pageNumber)}
          variant={page === pageNumber ? "contained" : "outlined"}
          sx={{
            borderRadius: "100%",
            width: "32px !important",
            minWidth: "32px",
            height: "32px !important",
            minHeight: "32px",
            backgroundColor:
              page === pageNumber
                ? theme.palette.primary.main
                : theme.palette.background.paper,
            color:
              page === pageNumber
                ? theme.palette.primary.contrastText
                : theme.palette.text.primary,
            "&:hover": {
              backgroundColor:
                page === pageNumber
                  ? theme.palette.primary.dark
                  : theme.palette.action.hover,
            },
          }}
        >
          {pageNumber + 1}
        </Button>
      ))}
      <Button
        onClick={() => setPage(page + 1)}
        disabled={page + 1 >= totalPages}
        endIcon={<NavigateNextIcon />}
        sx={{
          width: "32px !important",
          minWidth: "32px",
        }}
      />
      <Button
        onClick={() => setPage(totalPages - 1)}
        disabled={page + 1 >= totalPages}
        endIcon={<LastPageIcon />}
        sx={{
          width: "32px !important",
          minWidth: "32px",
        }}
      />
    </Box>
  );
}

export default Pagination;
